module.exports = __webpack_public_path__ + "img/LogoVF.917b597b.png";